import React from 'react';
import i18n from 'i18next';
import Guest from '@/Layouts/Guest';
import {Head, Link, usePage} from '@inertiajs/inertia-react';
import ProductLogo from "@/Components/ProductLogo";

export default function Select() {
    return (
        <Guest>
            <Head title="Select Organization" />
            <div className="outside-logo"><ProductLogo /></div>
            <div className="select-organization">
                <div className="title">{i18n.t("selectorganization.choose-your-organization")}</div>
                    {usePage().props.organizations.map(organization =>
                        <Link
                            key={organization.uuid}
                            className="btn btn-toolbar organization-logo"
                            as="button"
                            href={route('organization.current')}
                            method="PUT"
                            data={{organization_uuid: organization.uuid}}
                            data-testid="select_organization-link-organization"
                        >
                            <span>{organization.name}</span>
                        </Link>
                    )}
            </div>
        </Guest>
    );
}
